/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Title_Number_SpacedInputs */

const en_ccsl_export_header_title_number_spaced = /** @type {(inputs: Ccsl_Export_Header_Title_Number_SpacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title #`)
};

const fr_ccsl_export_header_title_number_spaced = /** @type {(inputs: Ccsl_Export_Header_Title_Number_SpacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre #`)
};

const de_ccsl_export_header_title_number_spaced = /** @type {(inputs: Ccsl_Export_Header_Title_Number_SpacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel #`)
};

const it_ccsl_export_header_title_number_spaced = /** @type {(inputs: Ccsl_Export_Header_Title_Number_SpacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo n.`)
};

const ru_ccsl_export_header_title_number_spaced = /** @type {(inputs: Ccsl_Export_Header_Title_Number_SpacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заголовок #`)
};

const es_ccsl_export_header_title_number_spaced = /** @type {(inputs: Ccsl_Export_Header_Title_Number_SpacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título #`)
};

const zh_cn2_ccsl_export_header_title_number_spaced = /** @type {(inputs: Ccsl_Export_Header_Title_Number_SpacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题 ＃`)
};

const ja_ccsl_export_header_title_number_spaced = /** @type {(inputs: Ccsl_Export_Header_Title_Number_SpacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトル ＃`)
};

const hi_ccsl_export_header_title_number_spaced = /** @type {(inputs: Ccsl_Export_Header_Title_Number_SpacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षक #`)
};

const pt_pt2_ccsl_export_header_title_number_spaced = /** @type {(inputs: Ccsl_Export_Header_Title_Number_SpacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título #`)
};

/**
* | output |
* | --- |
* | "Title #" |
*
* @param {Ccsl_Export_Header_Title_Number_SpacedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_title_number_spaced = /** @type {((inputs?: Ccsl_Export_Header_Title_Number_SpacedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Title_Number_SpacedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_title_number_spaced(inputs)
	if (locale === "de") return de_ccsl_export_header_title_number_spaced(inputs)
	if (locale === "it") return it_ccsl_export_header_title_number_spaced(inputs)
	if (locale === "ru") return ru_ccsl_export_header_title_number_spaced(inputs)
	if (locale === "es") return es_ccsl_export_header_title_number_spaced(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_title_number_spaced(inputs)
	if (locale === "ja") return ja_ccsl_export_header_title_number_spaced(inputs)
	if (locale === "hi") return hi_ccsl_export_header_title_number_spaced(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_title_number_spaced(inputs)
	return en_ccsl_export_header_title_number_spaced(inputs)
});